import { Grid, styled } from '@mui/material';
import { Fragment } from 'react';

import CustomerReportTable from './shared/CustomerReportTable';

const ContentBox = styled('div')(({ theme }) => ({
  margin: '30px',
  [theme.breakpoints.down('sm')]: { margin: '16px' }
}));

const CustomerReport = () => {
  return (
    <Fragment>
      <ContentBox className='analytics'>
        <Grid container spacing={3}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <CustomerReportTable />
          </Grid>
        </Grid>
      </ContentBox>
    </Fragment>
  );
};

export default CustomerReport;
